import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  sortBy: "",
  sortOrder: "desc",
  search: "",

  isEdit: false,
  showCreateModal: false,
  showDetailsModal: false,
  clearSelection: false,
  selectedId: "",

  /** The offer being edited, taken from the row rather than refetched. */
  editOfferData: {},

  /** Last answer from corporate-offer/preview - seat value and the liability figure. */
  pricing: {},
  isPricingLoading: false,
};

const corporateOfferSlice = createSlice({
  name: "corporateOffer",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = corporateOfferSlice.actions;
export default corporateOfferSlice.reducer;
